/**
 * @generated SignedSource<<79adcbd6d1e94a66784096694b907fb9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionActionBid_viewer$data = {
  readonly originalListPricePdpFF: boolean | null;
  readonly " $fragmentType": "PdpSharedAuctionActionBid_viewer";
};
export type PdpSharedAuctionActionBid_viewer$key = {
  readonly " $data"?: PdpSharedAuctionActionBid_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionActionBid_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionActionBid_viewer",
  "selections": [
    {
      "alias": "originalListPricePdpFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "originalListPricePdp"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"originalListPricePdp\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "7a6c15731b98634c5a48bc5d1daaa43f";

export default node;
